<div class="social-login-container">
  @defer (on idle) {
    <!-- <app-google-login-button (loginWithGoogleClick)="loginWithGoogle()" /> -->
    <asl-google-signin-button type="icon" size="large" shape="circle" theme="outline" />
  }
  <app-apple-login-button (loginWithAppleClick)="onLoginWithApple()" />
</div>
